export default "__VITE_ASSET__f1cdd1fa__"